import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'onlinedoc'
})
export class OnlinedocPipe implements PipeTransform {

  transform(data: any, online: any): any {
    if (!online || online.length<1){
      data = [0];

      return data;
    }
    else{
      var on=[];
      for(let d in data){
        for(let o in online){
          if(data[d].id==online[o].serviceprovider_id){
            on.push(data[d]);
            break;
          }


        }
      }
        return on;
    }
    
  }

}